import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import CloudSmartLayout from "../../components/cloudsmartlayout"
import CloudSmartSEO from "../../components/cloudsmartseo"

import "../../style/main.scss"

import CloudSmartSubNav from "../../components/cloudsmartsubnav"
import CloudSmartAbout from "../../components/cloudsmartabout"
import CloudSmartSpeakers from "../../components/cloudsmartspeakers"
import CloudSmartAgenda from "../../components/cloudsmartagenda"
import CloudSmartJoinus from "../../components/cloudsmartjoinus"
import Location from "../../components/location"



const IndexPage = () => {
  const data = useStaticQuery(graphql`
      query {
        site {
          siteMetadata {
            speakers {
              name
              title
              image
              disabledProfile
              event
            }
            sponsorshipLevel
            sponsors {
              name
              level
              logo
              url
              width
              event
            }
            sessions {
              startTime
              endTime
              title
              description
              type
              speakers {
                name
                isModerator
              }
              event
            }
          }
        }
      }
    `)

  const {
    speakers,
    sessions,
    sponsors,
    sponsorshipLevel
  } = data.site.siteMetadata

  return (
    <CloudSmartLayout>
      <CloudSmartSEO title="Cloud Smart Live 2020 | Aug" />
      <CloudSmartSubNav />
      <CloudSmartAbout sponsors={sponsors} sponsorshipLevel={sponsorshipLevel} />
      <CloudSmartSpeakers speakers={speakers} />
      <CloudSmartAgenda sessions={sessions} speakers={speakers} />
      <CloudSmartJoinus />
      
    </CloudSmartLayout>
  )
}

export default IndexPage